export default __webpack_public_path__ + "static/avatar-kortical-team3--mobile-a33098dc995945f6d0cddce33b1e9f50.jpg";